import {
  ADD_REMINDER,
  ADD_TO_CART,
  ADD_TO_WATCHLIST,
  CANCEL_SELLING,
  CHECKOUT_ITEM,
  DELETE_FROM_CART,
  GET_AUCTION_FROM_MARKET,
  GET_CART,
  GET_FIXEDPRICE_FROM_MARKET,
  GET_ITEM_DETAILS,
  GET_ITEM_FROM_MARKET,
  GET_MARKET_MY_BID,
  GET_MARKET_MY_ORDERS,
  GET_MARKET_SALE_ITEM,
  GET_MARKET_WATCHLIST,
  GET_MY_ITEM_FROM_MARKET,
  GET_REQUESTED_ITEMS,
  GET_REQUESTED_ITEM_DETAILS,
  POST_ITEM_TO_MARKET,
  REQUEST_OUT,
  SELL_ITEM,
  UPDATE_REQUESTED_ITEM_STATUS,
} from '../actionTypes';

const initialState = {
  myItems: [],
  data: [],
  cart: [],
  auctions: [],
  fixedPrice: [],
  bids: [],
  watchlist: [],
  orders: [],
  sales: [],
  isLoading: false,
  error: false,
  message: '',
  newItem: false,
  checkedOut: false,
  selectedItem: {},
  forSale: false,
  newRO: false,
  requestedItems: [],
  requestedItemDetails: {},
  paidItem: false,
  submitted: false,
  totalPage: 0,
  currentPage: 0,
  addedToCart: false,
  deletedFromCart: false,
  newWatchlist: false,
  loadingWatchlist: false,
  requestStatus: [],
  overview: {
    auction: {
      percent: 0,
      total: 0,
    },
    fixed_price: {
      percent: 0,
      total: 0,
    },
    on_sale: {
      percent: 0,
      total: 0,
    },
  },

  canceled: false,
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case `${ADD_TO_CART}_PENDING`:
      return {
        ...state,
        error: false,
        addedToCart: false,
      };
    case `${ADD_TO_CART}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${ADD_TO_CART}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        addedToCart: true,
      };
    case `${ADD_REMINDER}_PENDING`:
      return {
        ...state,
        error: false,
      };
    case `${ADD_REMINDER}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${ADD_REMINDER}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        selectedItem: { ...state.selectedItem, reminder: true },
      };
    case `${DELETE_FROM_CART}_PENDING`:
      return {
        ...state,
        error: false,
        deletedFromCart: false,
      };
    case `${DELETE_FROM_CART}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${DELETE_FROM_CART}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        deletedFromCart: true,
        cart: state.cart.filter((item) => item.id !== payload.data),
      };

    case `${ADD_TO_WATCHLIST}_PENDING`:
      return {
        ...state,
        error: false,
        newWatchlist: false,
        loadingWatchlist: true,
      };
    case `${ADD_TO_WATCHLIST}_REJECTED`:
      return {
        ...state,
        loadingWatchlist: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${ADD_TO_WATCHLIST}_FULFILLED`:
      return {
        ...state,
        loadingWatchlist: false,
        error: false,
        message: '',
        newWatchlist: true,
        selectedItem: {
          ...state.selectedItem,
          is_watched: true,
        },
      };
    case `${POST_ITEM_TO_MARKET}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        newItem: false,
      };
    case `${POST_ITEM_TO_MARKET}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${POST_ITEM_TO_MARKET}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        newItem: true,
      };

    case `${GET_ITEM_FROM_MARKET}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        newItem: false,
        selectedItem: {},
        data: [],
        currentPage: 0,
      };
    case `${GET_ITEM_FROM_MARKET}_REJECTED`:
      return {
        ...state,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
        isLoading: false,
      };
    case `${GET_ITEM_FROM_MARKET}_FULFILLED`:
      return {
        ...state,
        error: false,
        message: '',
        data: payload.data.data,
        totalPage: payload.data.total_page,
        currentPage: payload.data.current_page,
        total: payload.data.total,
        isLoading: false,
      };

    case `${GET_MY_ITEM_FROM_MARKET}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        newItem: false,
        selectedItem: {},
      };
    case `${GET_MY_ITEM_FROM_MARKET}_REJECTED`:
      return {
        ...state,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
        isLoading: false,
      };
    case `${GET_MY_ITEM_FROM_MARKET}_FULFILLED`:
      return {
        ...state,
        error: false,
        message: '',
        myItems: payload.data.data,
        overview: payload.data.overview,
        totalPage: payload.data.total_page,
        currentPage: payload.data.current_page,
        total: payload.data.total,
        isLoading: false,
      };

    case `${GET_MARKET_MY_BID}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        newItem: false,
        selectedItem: {},
        currentPage: 0,
      };
    case `${GET_MARKET_MY_BID}_REJECTED`:
      return {
        ...state,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
        isLoading: false,
      };
    case `${GET_MARKET_MY_BID}_FULFILLED`:
      return {
        ...state,
        error: false,
        message: '',
        bids: payload.data.data || [],
        totalPage: payload.data.total_page,
        currentPage: payload.data.current_page,
        total: payload.data.total,
        isLoading: false,
      };

    case `${GET_MARKET_WATCHLIST}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        newItem: false,
        selectedItem: {},
        currentPage: 0,
      };
    case `${GET_MARKET_WATCHLIST}_REJECTED`:
      return {
        ...state,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
        isLoading: false,
      };
    case `${GET_MARKET_WATCHLIST}_FULFILLED`:
      return {
        ...state,
        error: false,
        message: '',
        watchlist: payload.data.data || [],
        totalPage: payload.data.total_page,
        currentPage: payload.data.current_page,
        total: payload.data.total,
        isLoading: false,
      };

    case `${GET_MARKET_MY_ORDERS}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        newItem: false,
        selectedItem: {},
        currentPage: 0,
      };
    case `${GET_MARKET_MY_ORDERS}_REJECTED`:
      return {
        ...state,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
        isLoading: false,
      };
    case `${GET_MARKET_MY_ORDERS}_FULFILLED`:
      return {
        ...state,
        error: false,
        message: '',
        orders: payload.data.data || [],
        totalPage: payload.data.total_page,
        currentPage: payload.data.current_page,
        total: payload.data.total,
        isLoading: false,
      };

    case `${GET_MARKET_SALE_ITEM}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        newItem: false,
        selectedItem: {},
        currentPage: 0,
      };
    case `${GET_MARKET_SALE_ITEM}_REJECTED`:
      return {
        ...state,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
        isLoading: false,
      };
    case `${GET_MARKET_SALE_ITEM}_FULFILLED`:
      return {
        ...state,
        error: false,
        message: '',
        sales: payload.data.data || [],
        totalPage: payload.data.total_page,
        currentPage: payload.data.current_page,
        total: payload.data.total,
        isLoading: false,
      };

    case `${GET_CART}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        newItem: false,
        cart: [],
        deletedFromCart: false,
        addedToCart: false,
      };
    case `${GET_CART}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: payload?.response?.data?.status || true,
      };
    case `${GET_CART}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        cart: payload.data.data || [],
      };
    case `${GET_AUCTION_FROM_MARKET}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        newItem: false,
        auctions: [],
      };
    case `${GET_AUCTION_FROM_MARKET}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${GET_AUCTION_FROM_MARKET}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        auctions: payload.data.data,
      };
    case `${GET_FIXEDPRICE_FROM_MARKET}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        newItem: false,
        fixedPrice: [],
      };
    case `${GET_FIXEDPRICE_FROM_MARKET}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${GET_FIXEDPRICE_FROM_MARKET}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        fixedPrice: payload.data.data,
      };

    case `${GET_REQUESTED_ITEMS}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
      };
    case `${GET_REQUESTED_ITEMS}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${GET_REQUESTED_ITEMS}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        requestedItems: payload.data.data,
      };
    case `${GET_REQUESTED_ITEM_DETAILS}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        requestedItemDetails: {},
        submitted: false,
      };
    case `${GET_REQUESTED_ITEM_DETAILS}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${GET_REQUESTED_ITEM_DETAILS}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        requestedItemDetails: payload.data.data,
      };

    case `${UPDATE_REQUESTED_ITEM_STATUS}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        submitted: false,
      };
    case `${UPDATE_REQUESTED_ITEM_STATUS}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${UPDATE_REQUESTED_ITEM_STATUS}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        requestedItemDetails: payload.data.data,
        submitted: true,
      };

    case `${GET_ITEM_DETAILS}_PENDING`:
      return {
        ...state,
        isLoading: true,
        detailsError: false,
        newItem: false,
        selectedItem: {},
        checkedOut: false,
        forSale: false,
        newRO: false,
        paidItem: false,
        addedToCart: false,
        canceled: false,
      };
    case `${GET_ITEM_DETAILS}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        detailsError: true,
      };
    case `${GET_ITEM_DETAILS}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        detailsError: false,
        message: '',
        selectedItem: payload.data.data,
      };

    case `${CHECKOUT_ITEM}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        newItem: false,
      };
    case `${CHECKOUT_ITEM}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${CHECKOUT_ITEM}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        checkedOut: true,
      };

    case `${SELL_ITEM}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        forSale: false,
      };
    case `${SELL_ITEM}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${SELL_ITEM}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        forSale: true,
      };
    case `${REQUEST_OUT}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        newRO: false,
      };
    case `${REQUEST_OUT}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${REQUEST_OUT}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        newRO: true,
      };
    case `${CANCEL_SELLING}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        canceled: false,
      };
    case `${CANCEL_SELLING}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${CANCEL_SELLING}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        canceled: true,
      };

    default:
      return state;
  }
}
